/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Advertiser } from './Advertiser';
import { Country } from './Country';
import { Placement } from './Placement';

const filterComponents = {
  placement: Placement,
  country: Country,
  advertiser: Advertiser,
};

export const RightBlock = ({ placementList$, countryList$, advertiserList$, currentFilter$ }) => {
  const DynamicComponent = filterComponents[currentFilter$.value];

  return (
    <Box>
      <DynamicComponent
        placementList$={placementList$}
        countryList$={countryList$}
        advertiserList$={advertiserList$}
      />
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
`;
